import { useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';

import { useAuthentication } from '@src/context/hooks';
import { useAPIClientBase } from '@src/corelib/api/client';

function useAPIClient() {
  const auth = useAuthentication();
  const navigate = useNavigate();

  const handle401 = useCallback(() => {
    navigate({ to: '/login' });
  }, [navigate]);

  return useAPIClientBase({ auth, on401: handle401 });
}

export default useAPIClient;
